import React, { useRef } from "react";
import { Button, Modal } from "antd";
import html2canvas from "html2canvas";

const RankTemplateModal = ({
  show,
  handleClose,
  rank,
  rankId,
  profilePhoto,
  fullName,
  state,
}) => {
  const cardRef = useRef(null);

  const handleSaveAsPNG = () => {
    if (cardRef.current) {
      const holder = cardRef.current.parentElement;
      const originalBackground = holder.style.backgroundColor;
      holder.style.backgroundColor = "transparent";

      html2canvas(cardRef.current, {
        scale: 2,
        useCORS: true,
        backgroundColor: null,
        // Render the clone at desktop width so mobile media queries don't apply,
        // and pin the template to 1000px so the PNG is always the square PC layout
        windowWidth: 1200,
        onclone: (document, clonedCard) => {
          clonedCard.style.width = "1000px";
        },
      }).then((canvas) => {
        holder.style.backgroundColor = originalBackground;
        const link = document.createElement("a");
        link.download = `${rank ?? "rank"}-rank-template.png`;
        link.href = canvas.toDataURL("image/png");
        link.click();
      });
    }
  };

  return (
    <Modal
      title="Rank Reward"
      open={show}
      onCancel={handleClose}
      className="award-reward-modal"
      footer={
        <div className="d-flex justify-content-between">
          <button
            className="bg-dark text-white rounded"
            style={{ zIndex: 999 }}
            onClick={handleSaveAsPNG}
          >
            Save as PNG
          </button>
          <Button onClick={handleClose}>Close</Button>
        </div>
      }
      width={1000}
    >
      <div ref={cardRef}>
        <div
          id="widget"
          className="rank_achivers_main_box"
          style={{
            backgroundImage: `url('/images/rank_achivers/${rank}/bg.jpg')`,
          }}
        >
          <div className="rank_achivers_contant_are">
            <div className="top_logo_section">
              <img src="/images/rank_achivers/logo.jpg" alt="" />
            </div>

            <div className="rank_achivers_left_sec">
              <div className="rank_achivers_left_rank_name_ico">
                {[11, 12, 13].includes(rankId) ? (
                  <img
                    className="rank_crowndmnd_achive"
                    src="/images/rank_achivers/crown.png"
                    alt=""
                  />
                ) : (
                  <>
                    <img
                      src={`/images/rank_achivers/${rank}/text.png`}
                      alt=""
                    />
                    <p>ACHIEVER</p>
                  </>
                )}
              </div>

              <div
                className="rank_achivers_photo"
                style={{
                  backgroundImage: `url('/images/rank_achivers/${rank}/photo-frame.png')`,
                }}
              >
                <span className="rank_achivers_photo_overlay" />
                <div className="rank_achivers_photo_frame">
                  <img src={`${profilePhoto}`} alt="" />
                </div>
              </div>

              <div
                id="nameResize"
                className="rank_achivers_name"
                style={{
                  "--name-lines": `url('/images/rank_achivers/${rank}/text_up_btm_line.png')`,
                }}
              >
                <span className="rank_achivers_name_line rank_achivers_name_line_top" />
                {fullName}
                <span className="rank_achivers_name_line rank_achivers_name_line_bottom" />
              </div>

              <div className="rank_achivers_state">
                <span>State</span>
                <strong>{state?.toUpperCase()}</strong>
              </div>
            </div>

            <div className="rank_achivers_right_sec">
              <div className="rank_achivers_right_star_sec_1"></div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default RankTemplateModal;
